<template>
  <modal-window v-on:close="$emit('closeSaveChangesWindow')">
    <template slot="header">
      <p class="modal-card-title">Save changes</p>
      <button class="delete" v-on:click="$emit('closeSaveChangesWindow')" aria-label="close"></button>
    </template>
    <template slot="body">
      <div class="field">
        <label class="label">Select file type</label>
        <div class="control">
          <label class="radio">
            <input type="radio" value="txt" v-model="fileType"> Text
          </label>
        </div>
        <div class="control">
          <label class="radio">
            <input type="radio" value="json" v-model="fileType"> Json
          </label>
        </div>
        <div class="control">
          <label class="radio">
            <input type="radio" value="markdown" v-model="fileType"> Markdown
          </label>
        </div>
      </div>

      <div class="field">
        <label class="label">Select save type</label>
        <div class="control">
          <label class="radio">
            <input type="radio" value="all" v-model="saveType"> Save all changes
          </label>
        </div>
        <div class="control">
          <label class="radio">
            <input type="radio" disabled value="founded" v-model="saveType"> Save founded changes
          </label>
        </div>
        <div class="control">
          <label class="radio">
            <input type="radio" value="lastVersion" v-model="saveType"> Save changes from the last version (that has changes; for release)
          </label>
        </div>
        <div class="control">
          <label class="radio">
            <input type="radio" value="currentVersion" v-model="saveType"> Save changes from the current version (for release)
          </label>
        </div>
      </div>

      <div class="field">
        <label class="label">Select language</label>
        <div class="control">
          <label class="radio">
            <input
              type="radio"
              value="english"
              v-model="language"
              v-bind:disabled="fileType == 'json'"
            > English
          </label>
        </div>
        <div class="control">
          <label class="radio">
            <input
              type="radio"
              value="russian"
              v-model="language"
              v-bind:disabled="fileType == 'json'"
            > Russian
          </label>
        </div>
      </div>

      <div class="field">
        <label class="label">Group by</label>
        <div class="control">
          <label class="radio">
            <input
              type="radio"
              value="minor"
              v-model="grouping"
              v-bind:disabled="isGroupingDisabled"
            > Minor
          </label>
        </div>
        <div class="control">
          <label class="radio">
            <input
              type="radio"
              value="build"
              v-model="grouping"
              v-bind:disabled="isGroupingDisabled"
            > Build
          </label>
        </div>
      </div>

      <div class="field">
        <label class="label">Filter by tag</label>
        <b-tooltip label="show changes, which includes tags(start with #, please)"
         position="is-right"
         multilined
        >
         <b-taginput
            placeholder="awesomechanges"
            v-bind:class="{ 'is-danger': !isValidTags && saveClicked }"
            v-model="tags"
            ellipsis
            icon="label"
          ></b-taginput>
          <p v-if="!isValidTags" class="help is-danger">Here should be some valid tags (#tag1 #tag2)</p>
        </b-tooltip>
      </div>

      <loading :active.sync="loading" :can-cancel="false" :is-full-page="false"></loading>
    </template>
    <template slot="footer">
      <a
        id="downloadBtn"
        class="button is-success"
        v-bind:download="filename"
        v-on:click="download"
      >Download</a>
      <button class="button is-success" v-on:click="preview">Preview</button>
      <button class="button" v-on:click="$emit('closeSaveChangesWindow')">Cancel</button>
    </template>
  </modal-window>
</template>

<script>
import ModalWindow from "./ModalWindow";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.min.css";
import * as downloader from "./download";

export default {
  name: "change-saver",
  components: { ModalWindow, Loading },
  props: {
    productId: Number,
    filterType: String
  },
  data() {
    return {
      saveType: "all",
      language: "english",
      fileType: "txt",
      grouping: "minor",
      version: -1,

      fileLink: "",
      filename: "",
      tags: [],
      loading: false
    };
  },
  computed: {
    isGroupingDisabled: function() {
      return (
        this.saveType == "lastVersion" || this.saveType == "currentVersion"
      );
    },
    isValidTags: function() {
       return true;
      // (
    //     this.tags.length == 0 ||
    //     (this.tags.match(/[a-zA-Z0-9_]+/g) || "").length ==
    //       (this.tags.split(/[\s,;]/) || "").length
    //   );
     }
  },
  methods: {
    preview() {
      if (this.isValidTags) {
        this.$emit(
          "saveChanges",
          this.saveType,
          this.language,
          this.fileType,
          this.grouping,
          this.tags
        );
      }
    },

    getCurrentVersion() {
      return new Promise((resolve, reject) => {
        this.loading = true;
        this.HTTP.get("productVersions/current/" + this.productId)
          .then(response => {
            this.loading = false;
            this.version = response.data.id;
            resolve();
          })
          .catch(e => {
            this.loading = false;
            console.log(e);
            reject();
          });
      });
    },
    getLastVersion() {
      return new Promise((resolve, reject) => {
        this.loading = true;
        this.HTTP.get("productVersions/last/" + this.productId)
          .then(response => {
            this.loading = false;
            this.version = response.data.id;
            resolve();
          })
          .catch(e => {
            this.loading = false;
            console.log(e);
            reject();
          });
      });
    },
    downloadChanges() {
      this.loading = true;
      this.HTTP.post("changes/product/file_v2", {
        productId: this.productId,
        fileType: this.fileType,
        grouping: this.grouping,
        filterType: this.filterType,
        tags: this.tags,
        fileType: this.fileType,
        language: this.language,
        VersionId:
          this.saveType == "currentVersion" || this.saveType == "lastVersion"
            ? this.version
            : null
      })
        .then(response => {
          let downloadingTxt;
          let chgs = response.data;
          if (chgs.length == 0)
            chgs +=
              "\nThere is no any changes in version " + this.version + "!";
          let btype = "text/plain";
          if (this.fileType == "txt" || this.fileType == "markdown") {
            this.filename =
              this.fileType == "markdown" ? "changes.md" : "changes.txt";
            btype = "text/plain";
            downloadingTxt = chgs;
          } else {
            this.filename = "changes.json";
            btype = "application/json";
            downloadingTxt = JSON.stringify(chgs);
          }
          let blob = new Blob([downloadingTxt]);
          downloader.download(blob, this.filename, btype);

          this.loading = false;
          this.$emit("closeSaveChangesWindow");
        })
        .catch(e => {
          console.log(e);
        });
    },
    download() {
      if (this.isValidTags) {
        if (this.saveType == "currentVersion") {
          this.getCurrentVersion().then(() => {
            this.downloadChanges();
          });
        } else if (this.saveType == "lastVersion") {
          this.getLastVersion().then(() => {
            this.downloadChanges();
          });
        } else {
          this.downloadChanges();
        }
      }
    }
  },
  created() {},
  watch: {
    saveType: function(newVal) {
      if (newVal == "lastVersion" || newVal == "currentVersion")
        this.grouping = "minor";
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/ChangesSaver.Vue